export default __webpack_public_path__ + "maps-examples-default-callout-1200-cc2d7575c80e839b70acd539ce6939a7.png";